import { render, staticRenderFns } from "./chemBaseDetail.vue?vue&type=template&id=72461c64"
import script from "./chemBaseDetail.vue?vue&type=script&lang=js"
export * from "./chemBaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72461c64')) {
      api.createRecord('72461c64', component.options)
    } else {
      api.reload('72461c64', component.options)
    }
    module.hot.accept("./chemBaseDetail.vue?vue&type=template&id=72461c64", function () {
      api.rerender('72461c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chem/chemBaseDetail.vue"
export default component.exports